import { createContext, useContext, type ReactNode } from "react";
import type { EventContent } from "@tih/shared";
import { EVENT_CONTENT } from "@tih/shared";

const EventContentContext = createContext<EventContent | null>(null);

export function EventContentProvider({
  content,
  children,
}: {
  content: EventContent | null;
  children: ReactNode;
}) {
  return (
    <EventContentContext.Provider value={content}>
      {children}
    </EventContentContext.Provider>
  );
}

/** Raw payload from Layout fetch — null until the public event API resolves. */
export function useEventContentOptional(): EventContent | null {
  return useContext(EventContentContext);
}

/** Resolved public event payload (falls back to bundled defaults while loading). */
export function useEventContent(): EventContent {
  const v = useContext(EventContentContext);
  return v ?? EVENT_CONTENT;
}
